/* Nightpass - header : logotype, menu au survol, lien compte */
(function () {
  var ACCOUNT_PAGE = '/pages/mon-compte';
  var LOGIN_URL = '/customer_authentication/login?return_to=' + ACCOUNT_PAGE;
  var CLOSE_DELAY = 180;

  function wordmark() {
    document.querySelectorAll('.header__heading-link').forEach(function (link) {
      if (link.querySelector('.np-wordmark')) return;
      var w = document.createElement('span');
      w.className = 'np-wordmark';
      var a = document.createElement('span');
      a.className = 'np-wordmark__strong';
      a.textContent = 'Nightpass';
      var b = document.createElement('span');
      b.className = 'np-wordmark__light';
      b.textContent = 'Shop';
      w.appendChild(a);
      w.appendChild(b);
      link.appendChild(w);
    });
  }

  function accountLink() {
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (a.hasAttribute('data-np-keep')) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/account') === -1) return;
      var path = href.split('#')[0].split('?')[0].replace(/\/$/, '');
      if (/(^|\/)account$/.test(path) || /(^|\/)account\/login$/.test(path)) {
        a.setAttribute('href', ACCOUNT_PAGE);
      }
    });
  }

  function loginButton() {
    document.querySelectorAll('a.np-btn--np').forEach(function (a) {
      a.setAttribute('href', LOGIN_URL);
    });
  }

  function hoverMenu() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    var menu = document.querySelector('.header__inline-menu');
    if (!menu) return;
    var items = menu.querySelectorAll('details');
    var timer = null;

    function closeAll(except) {
      items.forEach(function (d) {
        if (d !== except && d.hasAttribute('open')) {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    }

    items.forEach(function (d) {
      if (d.dataset.npHover) return;
      d.dataset.npHover = '1';
      var summary = d.querySelector('summary');

      d.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        closeAll(d);
        if (!d.hasAttribute('open')) {
          d.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      });

      d.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          d.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      });

      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (!d.hasAttribute('open')) {
            closeAll(d);
            d.setAttribute('open', '');
            summary.setAttribute('aria-expanded', 'true');
          }
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  function init() {
    wordmark();
    accountLink();
    loginButton();
    hoverMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
